var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',_vm._g(_vm._b({staticClass:"ui-checkbox-group",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}},'el-checkbox-group',_vm.$attrs,false),_vm.forwardedListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }